import { createStore } from 'vuex';

export default createStore({
  state: {
    keepAliveArr: [],
    developEnv: process.env.NODE_ENV === 'development',
    userInfo: {}
  },
  mutations: {
    /** 设置用户信息 */
    setUserInfo (state, params) {
      state.userInfo = params;
    },
    setKeepAliveArr (state, params) {
      state.keepAliveArr = [...state.keepAliveArr, ...params];
    }
  },
  actions: {
  },
  modules: {
  }
});
